export const reusableGraphConfig = {
  colors: ['#10C98F', '#376F66', '#FEF0DE'],
  colorsAsClasses: ['bg-bright-green', 'bg-green', 'bg-corn'],
  lineProps: {
    strokeWidth: 4,
    label: false,
    dot: false,
    type: 'linear',
    animationDuration: 300,
  },
  xAxisProps: {
    axisLine: false,
    tickLine: false,
    domain: ['dataMin', 'dataMax'],
    tickCount: 5,
    type: 'number',
    interval: 'preserveEnd'
  },
  yAxisProps: {
    axisLine: false,
    tickLine: false,
    domain: [0, 'auto']
  }
}

export default reusableGraphConfig;
